import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'
import { COLORS } from '../data/enums'
import Iris from './Iris/Iris'

export default function FaceFeature({
  scaleX,
  scale,
  gradient,
  pupil,
  rotation = 0,
  spacing = 0,
  verticalOffset,
  outline,
  showEyeLiner,
}) {
  const randomGradientId1 = `_${useRandomId()}`
  const randomGradientId2 = `_${useRandomId()}`

  const leftPupilTransformOrigin = '15.72 14.65'
  const rightPupilTransformOrigin = '43.72 14.65'

  const leftEyePath = 'M5.72,11.35s13.19-6.72,18,6.26c0,0-10.66,7.39-18-6.26Z'
  const rightEyePath = 'M53.72,11.35s-13.19-6.72-18,6.26c0,0,10.66,7.39,18-6.26Z'

  return (
    <>
      <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`}>
        {/* LEFT EYE */}
        <g transform={`scale(${scale},${scale}) translate(${-spacing})`} transform-origin={leftPupilTransformOrigin}>
          <g transform={`rotate(${rotation})`} transform-origin="inherit">
            <path className="cls-2" d={leftEyePath} fill={COLORS.WHITE} />
            <Iris
              rotation={-rotation}
              maskPath={leftEyePath}
              gradientId={randomGradientId1}
              transformOrigin={leftPupilTransformOrigin}
            />
            <path
              className="cls-4"
              d="M15.72,17.15c1.38,0,2.5-1.12,2.5-2.5s-1.12-2.5-2.5-2.5-2.5,1.12-2.5,2.5,1.12,2.5,2.5,2.5Z"
              fill={pupil}
            />
            <path
              className="cls-3"
              d="M17.06,20.11c-.81,0-1.67-.09-2.55-.3-3.66-.88-6.76-3.64-9.23-8.23l-.24-.45,.46-.23c.26-.13,6.39-3.2,11.96-1.02,3.06,1.19,5.32,3.74,6.74,7.56l.13,.36-.32,.22c-.15,.1-3.07,2.09-6.94,2.09ZM6.42,11.58c2.28,4.04,5.07,6.48,8.31,7.26,3.88,.93,7.32-.82,8.38-1.43-1.31-3.33-3.34-5.54-6.01-6.59-4.31-1.68-9.17,.11-10.68,.77Z"
              fill={outline}
            />
            {showEyeLiner && <path d="M5.04,11.13c7.09-4.51,17.72-2.59,19.29,6.66-4.2-7.79-11.39-8.34-19.29-6.66h0Z" />}
          </g>
          <path
            className="cls-2"
            d="M17.39,13.8c.46,0,.83-.37,.83-.83s-.37-.83-.83-.83-.83,.37-.83,.83,.37,.83,.83,.83Z"
            fill={COLORS.WHITE}
          />
        </g>
        {/* RIGHT EYE */}
        <g transform={`scale(${scale},${scale}) translate(${spacing})`} transform-origin={rightPupilTransformOrigin}>
          <g transform={`rotate(${-rotation})`} transform-origin="inherit">
            <path className="cls-2" d={rightEyePath} fill={COLORS.WHITE} />
            <Iris
              rotation={rotation}
              maskPath={rightEyePath}
              gradientId={randomGradientId2}
              transformOrigin={rightPupilTransformOrigin}
            />
            <path
              className="cls-4"
              d="M43.72,17.15c1.38,0,2.5-1.12,2.5-2.5s-1.12-2.5-2.5-2.5-2.5,1.12-2.5,2.5,1.12,2.5,2.5,2.5Z"
              fill={pupil}
            />
            <path
              className="cls-3"
              d="M42.38,20.11c-3.88,0-6.8-1.99-6.94-2.09l-.32-.22,.13-.36c1.41-3.82,3.68-6.36,6.74-7.56,5.57-2.18,11.7,.89,11.96,1.02l.46,.23-.24,.45c-2.46,4.58-5.57,7.35-9.23,8.23-.88,.21-1.74,.3-2.55,.3Zm-6.05-2.71c1.05,.62,4.5,2.37,8.38,1.43,3.24-.78,6.03-3.22,8.31-7.26-1.51-.65-6.37-2.45-10.68-.77-2.68,1.05-4.7,3.26-6.01,6.59Z"
              fill={outline}
            />
            {showEyeLiner && (
              <path d="M35.12,17.79c1.57-9.25,12.21-11.17,19.29-6.66-1.92-.38-3.8-.64-5.67-.74-6-.45-10.72,2.08-13.62,7.4h0Z" />
            )}
          </g>
          <path
            className="cls-2"
            d="M45.39,13.8c.46,0,.83-.37,.83-.83s-.37-.83-.83-.83-.83,.37-.83,.83,.37,.83,.83,.83Z"
            fill={COLORS.WHITE}
          />
        </g>
      </g>

      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="15.72"
          y1="111.66"
          x2="15.72"
          y2="121.1"
          gradientTransform="translate(0 131.24) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".27" stopColor={gradient[1]} />
          <stop offset="1" stopColor={gradient[0]} />
        </linearGradient>
        <linearGradient
          id={randomGradientId2}
          x1="43.72"
          y1="111.69"
          x2="43.72"
          y2="121.15"
          gradientTransform="translate(0 131.24) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".27" stopColor={gradient[1]} />
          <stop offset="1" stopColor={gradient[0]} />
        </linearGradient>
      </defs>
    </>
  )
}
